import { useState, useEffect } from 'react';
import { getUsers, deleteUser } from '../services/api';
import api from '../services/api';

export default function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: 'staff123', admin_role: 'manager' });

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const all = await getUsers();
      setStaff(all.filter(u => u.role === 'admin'));
    } catch (_) {}
    setLoading(false);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) { alert('Fill all fields'); return; }
    setSaving(true);
    try {
      await api.post('/admin/staff', form);
      alert(`✅ Staff created!\nEmail: ${form.email}\nPassword: ${form.password}\nRole: ${form.admin_role}`);
      setShowForm(false);
      setForm({ name: '', email: '', phone: '', password: 'staff123', admin_role: 'manager' });
      load();
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to create staff');
    }
    setSaving(false);
  };

  const handleRemove = async (id, name) => {
    if (!window.confirm(`Remove staff "${name}"?`)) return;
    try { await deleteUser(id); load(); } catch (e) { alert('Failed'); }
  };

  const roleBadge = (r) => {
    if (r === 'super_admin') return <span className="badge badge-danger">👑 Super Admin</span>;
    if (r === 'manager') return <span className="badge badge-info">📋 Manager</span>;
    if (r === 'support') return <span className="badge badge-success">🎧 Support</span>;
    if (r === 'franchise') return <span className="badge badge-warning">🏪 Franchise</span>;
    return <span className="badge badge-grey">Admin</span>;
  };

  return (
    <div>
      <div className="page-header">
        <h1>👤 Staff Management</h1>
        <p>Manage admin panel access for your team</p>
      </div>

      {/* Role explanation */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 24 }}>
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 16 }}>
          <h4 style={{ margin: '0 0 6px', color: '#dc2626' }}>👑 Super Admin</h4>
          <p style={{ margin: 0, fontSize: 12, color: '#666' }}>Full access — revenue, payments, refunds, bank details, staff management, all settings</p>
        </div>
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: 16 }}>
          <h4 style={{ margin: '0 0 6px', color: '#2563eb' }}>📋 Manager</h4>
          <p style={{ margin: 0, fontSize: 12, color: '#666' }}>Bookings, workers, customers, services, categories, tickets, reviews. NO revenue/payments/bank details</p>
        </div>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: 16 }}>
          <h4 style={{ margin: '0 0 6px', color: '#16a34a' }}>🎧 Support</h4>
          <p style={{ margin: 0, fontSize: 12, color: '#666' }}>Tickets, bookings (view only), dashboard stats only. Minimal access</p>
        </div>
      </div>

      {/* Add Staff Form */}
      {showForm && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header">
            <h2>➕ Add Staff Member</h2>
            <button className="btn btn-sm btn-danger" onClick={() => setShowForm(false)}>✕</button>
          </div>
          <form onSubmit={handleCreate} style={{ padding: '0 20px 20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group"><label>Name</label><input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
              <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required /></div>
              <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} required /></div>
              <div className="form-group"><label>Password</label><input value={form.password} onChange={e => setForm({...form, password: e.target.value})} required /></div>
              <div className="form-group">
                <label>Role</label>
                <select value={form.admin_role} onChange={e => setForm({...form, admin_role: e.target.value})}>
                  <option value="manager">📋 Manager</option>
                  <option value="support">🎧 Support</option>
                  <option value="franchise">🏪 Franchise</option>
                </select>
              </div>
              {form.admin_role === 'franchise' && (
                <div className="form-group">
                  <label>Franchise Area (City Name)</label>
                  <input value={form.franchise_area || ''} onChange={e => setForm({...form, franchise_area: e.target.value})} placeholder="e.g., Karimnagar" required />
                </div>
              )}
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Creating...' : '✅ Create Staff'}
            </button>
          </form>
        </div>
      )}

      {/* Staff List */}
      <div className="card">
        <div className="card-header">
          <h2>All Staff ({staff.length})</h2>
          <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>➕ Add Staff</button>
        </div>
        {loading ? <div className="loading">Loading...</div> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr><th>ID</th><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Status</th><th>Action</th></tr>
              </thead>
              <tbody>
                {staff.map(s => (
                  <tr key={s.id}>
                    <td>#{s.id}</td>
                    <td><strong>{s.name}</strong></td>
                    <td>{s.email}</td>
                    <td>{s.phone}</td>
                    <td>{roleBadge(s.admin_role)}</td>
                    <td>{s.is_active ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Inactive</span>}</td>
                    <td>
                      {s.admin_role !== 'super_admin' && (
                        <button className="btn btn-sm btn-danger" onClick={() => handleRemove(s.id, s.name)}>🗑️ Remove</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
